// config/auth.js - Authentication configuration
export const AUTH_CONFIG = {
    STATIC_PASSWORD: 'Hentai219561624Ss$$90',
    SESSION_KEY: 'accessDashboard_authenticated',
    SESSION_DURATION: 24 * 60 * 60 * 1000, // 24 hours in milliseconds
};